import { jsx as _jsx } from "react/jsx-runtime";
import { Tag } from 'antd';
import { Icon } from '../icons/icon.js';
import { useInTable } from '../antd/in-table-context.js';
import { Tooltip } from '../antd/overlays.js';
const TONE_COLOR = {
    success: 'success',
    warning: 'warning',
    danger: 'error',
    progress: 'processing',
    // `undefined` is AntD's neutral tag — a real value, not a missing one.
    inert: undefined,
};
export function StatusTag({ tone, children, hint, icon, className }) {
    const inTable = useInTable();
    const hinted = hint !== undefined && hint !== null && hint !== false && hint !== '';
    const classes = [hinted ? 'bk-status-tag--hint' : null, className].filter(Boolean).join(' ');
    const tag = (_jsx(Tag, { color: TONE_COLOR[tone], className: classes || undefined, icon: icon ? _jsx(Icon, { name: icon, size: 16 }) : undefined, "data-tone": tone, 
        // A hint is something to reach, not just to hover: the chip is a tab
        // stop on a page. In a table cell it is not (fifty rows would be fifty
        // stops, and the row's drawer carries the same status); the hint is its
        // description either way.
        tabIndex: hinted && !inTable ? 0 : undefined, "aria-description": typeof hint === 'string' && hint ? hint : undefined, children: children }));
    return hinted ? _jsx(Tooltip, { title: hint, children: tag }) : tag;
}
//# sourceMappingURL=status-tag.js.map